import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert } from 'lucide-react';
import { cn } from '../../lib/cn.js';
/**
 * Helper / error text (README.md > Atoms > "Tooltip, divider, helper/error
 * text"). Error state always carries the circular "!" glyph — colour never
 * carries meaning alone.
 *
 * ── Why an error announces itself ────────────────────────────────────────
 *
 * A field that goes wrong is told to the eye three ways — a red border, a
 * glyph and a sentence — and until now was told to a screen reader only if the
 * reader happened to be on that field. `aria-invalid` marks the input, but
 * nothing said the message had appeared, so submitting a form with a mistake
 * in it was silence.
 *
 * `role="alert"` on the error tone fixes that for every form in the product at
 * once, because every field message in the design system renders through here.
 * It is on the error tone only: helper text is there before anyone interacts
 * and interrupting for it would be noise. A caller that needs the announcement
 * suppressed can pass its own `role`, which lands after this in the spread.
 */
export function FieldMessage({ tone = 'helper', className, children, ...props }) {
    const isError = tone === 'error';
    return (_jsxs("p", { ...(isError ? { role: 'alert' } : {}), className: cn('flex items-start gap-1.5 text-body-sm', isError ? 'font-medium text-error-text' : 'font-normal text-text-secondary', className), ...props, children: [isError ? _jsx(CircleAlert, { className: "mt-0.5 size-icon-sm shrink-0", "aria-hidden": "true" }) : null, _jsx("span", { children: children })] }));
}
//# sourceMappingURL=FieldMessage.js.map